import { UserEducation } from 'generated/graphql'

export const SCHOOL_TYPES = [
  { label: '고등학교', value: UserEducation.HIGH_SCHOOL_GRADUATE },
  { label: '대학교(2,3년)', value: UserEducation.COLLEGE_GRADUATE_2_3_YEARS },
  { label: '대학교(4년)', value: UserEducation.COLLEGE_GRADUATE_4_YEARS },
  { label: '대학원', value: UserEducation.MASTER_GRADUATE },
]
